import Vue from 'vue'
import App from './App.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
Vue.config.productionTip = false
Vue.component('DatePicker', DatePicker)

new Vue({
  render: h => h(App),
}).$mount('#app')
